import Swiper from "swiper";
import SwiperCore, { Navigation, Pagination } from "swiper/core";
import { register } from "@shopify/theme-sections";

register("ring-gallery", {
  onLoad() {
    SwiperCore.use([Navigation, Pagination]);
    var prodswiper = new Swiper(".swiper-container-ring-gallery", {
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".ring-gallery-button-next",
        prevEl: ".ring-gallery-button-prev",
      },
    });
  },
});
